<div class="rec-amg__header">
  <span class="rec-amg__title">
    <ng-icon name="lucideWand2" size="14" aria-hidden="true" />
    Auto Mic Gain
  </span>

  <button
    type="button"
    class="rec-amg__switch"
    role="switch"
    [attr.aria-checked]="enabled()"
    [attr.aria-label]="enabled() ? 'Turn Auto Mic Gain off' : 'Turn Auto Mic Gain on'"
    [disabled]="disabled()"
    (click)="onToggle()"
    ssTooltip="Automatically finds the best microphone level for recording"
  >
    <span class="rec-amg__switch-track" aria-hidden="true">
      <span class="rec-amg__switch-knob"></span>
    </span>
  </button>
</div>

@if (stateAttr !== 'off') {
<div class="rec-amg__body" [attr.data-state]="stateAttr" aria-live="polite" aria-atomic="true">
  @switch (stateAttr) {
    @case ('calculating') {
      <p class="rec-amg__hint">Sing or speak normally for a few seconds…</p>
      <div
        class="rec-amg__progress"
        role="progressbar"
        aria-label="Calibration progress"
        [attr.aria-valuenow]="progressPct()"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div class="rec-amg__progress-fill" [style.width.%]="progressPct()"></div>
      </div>
    }

    @case ('complete') {
      <p class="rec-amg__hint rec-amg__hint--success">
        <ng-icon name="lucideCheck" size="14" aria-hidden="true" />
        Calibration Complete
      </p>
      <p class="rec-amg__best">Best Level: <strong>{{ bestLevelLabel() }}</strong></p>
      <p class="rec-amg__hint">Optimized for recording.</p>
    }

    @case ('calibrated') {
      <p class="rec-amg__best">Best Level: <strong>{{ bestLevelLabel() }}</strong></p>
      <button
        type="button"
        class="rec-amg__secondary"
        (click)="recalibrate()"
        [disabled]="disabled()"
        ssTooltip="Run microphone level calibration again"
      >
        <ng-icon name="lucideRotateCcw" size="14" aria-hidden="true" />
        Recalibrate
      </button>
    }
  }
</div>
}
